import styled from 'styled-components';
import rj1 from '../../../assets/RJ/1.jpg';
import rj2 from '../../../assets/RJ/2.jpg';
import rj3 from '../../../assets/RJ/3.jpg';
import rj4 from '../../../assets/RJ/4.jpg';
import rj5 from '../../../assets/RJ/5.jpg';
import rj6 from '../../../assets/RJ/6.jpg';
import rj7 from '../../../assets/RJ/7.jpg';

const images = [rj1, rj2, rj4, rj3, rj6, rj7];

// Contenedor de la grilla
const Grid = styled.div`
  margin-top: 200px;

  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;

  @media (max-width: 470px) {
    padding: 14px;
  }

  @media (min-width: 300px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

// Contenedor de cada imagen
const ImageWrapper = styled.div`
  overflow: hidden;
`;

// Imagen
const StyledImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
`;

export default function Photos() {
  return (
    <Grid>
      {images.map((src, index) => (
        <AnimatedImage key={index} src={src} index={index} />
      ))}
    </Grid>
  );
}

function AnimatedImage({ src, index }) {
  return (
    <ImageWrapper>
      <StyledImage src={src} alt="imagen" />
    </ImageWrapper>
  );
}
